import { Box, Button, Container, Stack, Typography, useTheme } from '@mui/material'
import { useNavigate } from 'react-router'
import { DipStripIcon, WaterSampleIcon } from '../../../components/icons'
import { Camera2Icon } from '../../../components/icons'
import ReactPixel from 'react-facebook-pixel'
import ReactGA from 'react-ga4'
import { TestStripHeader } from '../../../components/Header'

interface StepProps {
  icon: React.ReactNode
  title: string
  description: string
}

const WaterTestHowToStep = ({ icon, title, description }: StepProps) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        // flex: 1,
        borderRadius: '50%',
        border: '1px solid #0F0E0E80',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: 300,
        height: 300,
        textAlign: 'center',
        px: 4,
        gap: 0.6,
      }}
    >
      {icon}
      <Typography
        fontSize={'1.2rem'}
        fontWeight={theme.typography.fontWeightBold}
        color={'primary.dark'}
      >
        {title}
      </Typography>
      <Typography
        fontSize={'1rem'}
        fontWeight={theme.typography.fontWeightMedium}
        color={theme.palette.grey[600]}
      >
        {description}
      </Typography>
    </Box>
  )
}

export const WaterTestHowTo = () => {
  const theme = useTheme()
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        width:'100%',
        height:'100%',
        overflowY:'auto',
        flexGrow:1,
        maxHeight: '100%',

      }}
    >
      <TestStripHeader />
      <Container maxWidth="lg">
        <Stack alignItems="center" spacing={6}>
          <Typography
            fontSize={{xs: "2rem", md:'2.2rem'}}
            fontWeight={theme.typography.fontWeightBold}
            color='text.primary'
            textAlign={'center'}
          >
            How to Use Your Test Strip
          </Typography>

          <Stack direction={{xs: "column",  md:"row"}} spacing={4} justifyContent="center" alignItems="center" order={{xs: 1, md: 0}}>
            <WaterTestHowToStep
              icon={<WaterSampleIcon sx={{ fontSize: '6rem' }} />}
              title="Collect water sample"
              description="Collect water sample in a clean container"
            />
            <WaterTestHowToStep
              icon={<DipStripIcon sx={{ fontSize: '6rem' }} />}
              title="Dip the strip in"
              description="Dip the test strip inside the container filled with water."
            />
            <WaterTestHowToStep
              icon={<Camera2Icon sx={{ fontSize: '6rem' }} />}
              title="Enter values"
              description="Match the colors to their value to complete the analysis."
            />
          </Stack>

          <Button
            variant="contained"
            size="large"
            onClick={() => {
              ReactPixel.trackCustom("click", {id:'start_test', name:"Start Test"})
              ReactGA.event({action: 'click', category:'User event tracking', label:'Start Test'})
              navigate('/test-strip')
            }}
            sx={{
              py: 1.5,
              px: 4,
              
            }}
            
          >
            Start My Test
          </Button>
        </Stack>
      </Container>
    </Box>
  )
}
